import { render, staticRenderFns } from "./TheGreetingsIdeasPanel.vue?vue&type=template&id=3d13fc9c&scoped=true"
import script from "./TheGreetingsIdeasPanel.vue?vue&type=script&lang=js"
export * from "./TheGreetingsIdeasPanel.vue?vue&type=script&lang=js"
import style0 from "./TheGreetingsIdeasPanel.vue?vue&type=style&index=0&id=3d13fc9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d13fc9c",
  null
  
)

export default component.exports